//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../Diagramming/BordersAndZones.js";
import "../no/LineColorFontWidthBuilder.js";
let d=[[[0,"ContinueZoneIndexingAcrossSheets",1,0],[0,"CornerZoneModification",1,0],[0,"CreateZoneLabels",1,0],[0,"CreateZoneMarkings",1,0],[0,"CreateZones",1,0],[0,"HorizontalSize",1,0],[0,"LabelColor",1,0],[0,"LabelFont",1,0],[0,"LabelHeight",1,0],[0,"LabelItalicized",1,0],[0,"LabelWidth",1,0],[0,"LabelsToSkip",1,0],[0,"MarkingHeight",1,0],[1,"MarkingLineColorWidth",0,"LineColorFontWidthBuilder",0],[0,"Origin",1,0],[0,"VerticalSize",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.SheetZoneSettingsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SheetZoneSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;